import axios from 'axios';

const AxiosInstanceUnauthorized = axios.create({
  baseURL: 'http://154.61.173.123:7000',
});

export default AxiosInstanceUnauthorized;
